
import { useState } from 'react';
import { RSVPFlowState } from '../context/types';

export const useRSVPStateMachine = (initialState?: RSVPFlowState) => {
  const [currentState, setCurrentState] = useState<RSVPFlowState>(initialState || 'initial');
  
  const goToNextStep = () => {
    switch (currentState) {
      case 'initial':
        // Skip guest_selection step if we're already on initial
        // since they both render the same component
        setCurrentState('verification');
        break;
      case 'guest_selection':
        setCurrentState('verification');
        break;
      case 'verification':
        setCurrentState('date_selection');
        break;
      case 'date_selection':
        // Go directly to feedback, skipping the time_selection step
        setCurrentState('feedback');
        break;
      case 'feedback':
        setCurrentState('selfie');
        break;
      case 'selfie':
        setCurrentState('success');
        break;
      default:
        // Do nothing for success state
        break;
    }
  };

  const goToPreviousStep = () => {
    switch (currentState) {
      case 'guest_selection':
        setCurrentState('initial');
        break;
      case 'verification':
        // Go back to the active guest selection step
        setCurrentState('guest_selection');
        break;
      case 'date_selection':
        setCurrentState('verification');
        break;
      case 'feedback':
        // Go back to date_selection instead of time_selection
        setCurrentState('date_selection');
        break;
      case 'selfie':
        setCurrentState('feedback');
        break;
      case 'success':
        // Do nothing for success state
        break;
      default:
        // Do nothing for initial state
        break;
    }
  };

  // Add the transitionTo method that was referenced but not defined
  const transitionTo = (state: RSVPFlowState) => {
    setCurrentState(state);
  };

  const reset = () => {
    setCurrentState('initial');
  };

  return {
    currentState,
    goToNextStep,
    goToPreviousStep,
    transitionTo,
    reset,
  };
};
